import { ImageWrapper as _ImageWrapper } from "@/lib/styles";
import { H2, P } from "@/lib/styles";
import styled from "styled-components";

export const Container = styled.div`
  margin-bottom: 5rem;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  align-items: center;
  ${({ theme }) => theme.mediaQueries.laptop} {
    // position shift on the illustrations will leave a generous gap
    margin-bottom: 10rem;
  }
`;

export const CoverContainer = styled.div`
  display: flex;
  flex-direction: column-reverse;
  grid-column: 1 / -1;
  align-items: center;
  ${({ theme }) => theme.mediaQueries.laptop} {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
  }
`;

export const Heading = styled(H2)`
  grid-column: 1 / -1;
  pointer-events: none; // if not, can't click on a button
  color: ${({ theme }) => theme.colors.red};
  margin-bottom: 2rem;
  opacity: 1;
  text-align: center;
  position: sticky;
  top: 50%;
  transform: translateY(-50%);
  z-index: 0;

  .lines {
    opacity: 1;
    transform: translateY(20px);
  }
`;

export const Text = styled.div`
  z-index: 1;
  background-color: ${({ theme }) => theme.colors.white};
  padding: 0.5rem 0;
  ${({ theme }) => theme.mediaQueries.laptop} {
    padding: 0.5rem 1.875rem;
  }
`;

export const Excerpt = styled(P)`
  grid-row-start: 1;
  margin-bottom: 2rem;

  opacity: 0;
  .lines {
    opacity: 0;
    transform: translateY(20px);
  }

  ${({ theme }) => theme.mediaQueries.laptop} {
    margin-bottom: 0;
  }
`;

export const ExcerptWrapper = styled.article`
  grid-row-start: 1;
  margin-bottom: 2rem;
  opacity: 0;
  transform: translateY(20px);

  ${({ theme }) => theme.mediaQueries.laptop} {
    margin-bottom: 0;
  }
`
